import { useState } from "react";
import { api } from "@/lib/api";
import SiteLayout from "@/components/site/SiteLayout";
import { toast } from "sonner";
import { MapPin, Phone, Globe } from "lucide-react";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.message.trim()) {
      toast.error("పేరు మరియు సందేశం తప్పనిసరి");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("మీ సందేశం పంపబడింది. ధన్యవాదాలు.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      toast.error("పంపడం విఫలం");
    } finally { setSubmitting(false); }
  };

  return (
    <SiteLayout>
      <div className="max-w-6xl mx-auto px-4 py-10">
        <div className="border-b-4 border-[#2E7D32] pb-4 mb-10">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#2E7D32]">Contact Us</div>
          <h1 className="font-heading-te text-4xl md:text-5xl font-black mt-1" data-testid="contact-title">సంప్రదించండి</h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <p className="font-body-te text-[#4A4A4A] leading-relaxed mb-6">
              మీ అభిప్రాయాలు, వార్తలు, సూచనలు మాకు తెలియజేయండి. ఉమ్మడి పాలమూరు ప్రాంతం నుండి తాజా సమాచారం అందించేందుకు మీ సహకారం అమూల్యం.
            </p>
            <ul className="space-y-5 font-body-te">
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#2E7D32] text-white flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#4A4A4A]">Region</div>
                  <div className="text-base">ఉమ్మడి పాలమూరు, తెలంగాణ &amp; ఆంధ్రప్రదేశ్</div>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#2E7D32] text-white flex items-center justify-center shrink-0">
                  <Phone className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#4A4A4A]">Phone</div>
                  <a href="tel:9010226164" className="text-base hover:text-[#2E7D32]" data-testid="contact-phone">9010226164</a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 bg-[#2E7D32] text-white flex items-center justify-center shrink-0">
                  <Globe className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#4A4A4A]">Website</div>
                  <a href="https://nallamalavoice.com" className="text-base hover:text-[#2E7D32]" data-testid="contact-website">nallamalavoice.com</a>
                </div>
              </li>
            </ul>
          </div>

          <form onSubmit={submit} className="border border-[#E5E4DC] bg-white p-6 nv-selectable" data-testid="contact-form">
            <h3 className="font-heading-te text-xl font-bold mb-4">మీ సందేశం పంపండి</h3>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="మీ పేరు *" className="w-full border border-[#E5E4DC] px-3 py-2 mb-3 font-body-te focus:outline-none focus:border-[#2E7D32]" data-testid="contact-name" />
            <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email (optional)" className="w-full border border-[#E5E4DC] px-3 py-2 mb-3 font-body-te focus:outline-none focus:border-[#2E7D32]" data-testid="contact-email" />
            <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone (optional)" className="w-full border border-[#E5E4DC] px-3 py-2 mb-3 font-body-te focus:outline-none focus:border-[#2E7D32]" data-testid="contact-phone-input" />
            <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="మీ సందేశం *" rows={5} className="w-full border border-[#E5E4DC] px-3 py-2 mb-3 font-body-te focus:outline-none focus:border-[#2E7D32]" data-testid="contact-message" />
            <button type="submit" disabled={submitting} className="w-full bg-[#2E7D32] hover:bg-[#1B5E20] text-white py-3 font-body-te font-semibold disabled:opacity-60" data-testid="contact-submit-btn">
              {submitting ? "పంపుతోంది..." : "పంపండి"}
            </button>
          </form>
        </div>
      </div>
    </SiteLayout>
  );
}
